import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, memo, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { ButtonDisabledContextProvider } from './disabled-context';
import { getVariant } from './helpers';
import { ButtonContent, ButtonWrapper, StyledLoader } from './styled';
export const Button = memo(forwardRef(function Button({ children, primary, secondary, critical, ghost, reducedGap, preventDefault, stopPropagation, onClick, dataTestId, ...props }, ref) {
    const { colors } = useTheme();
    const variant = getVariant({ primary, secondary, critical, ghost });
    const loaderColor = useMemo(() => {
        if (variant === 'primary' || variant === 'critical')
            return colors.grey00_2;
        if (variant === 'ghost')
            return colors.black_2;
        return colors.black_1;
    }, [variant, colors]);
    const handleClick = useCallbackRef((e) => {
        if (preventDefault) {
            e.preventDefault();
        }
        if (stopPropagation) {
            e.stopPropagation();
        }
        if (!props.isLoading) {
            onClick?.(e);
        }
    });
    return (_jsxs(ButtonWrapper, { type: 'button', variant: variant, onClick: handleClick, ref: ref, "data-testid": dataTestId, ...props, children: [props.isLoading && _jsx(StyledLoader, { content: true, size: '16px', fill: loaderColor }), _jsx(ButtonContent, { reducedGap: reducedGap, isLoading: props.isLoading, children: _jsx(ButtonDisabledContextProvider, { disabled: !!props.disabled, children: children }) })] }));
}));
